<template>
  <div id="app">
    <navbar></navbar>
    <main class="py-3">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import navbar from './components/Navbar'
export default {
  components: {
    navbar
  }
}
</script>
<style>
  @import 'https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"';
</style>
